module.exports = __webpack_public_path__ + "img/red-circle-table-4.5e58d7cf.png";